import { createSelector as createReselectSelector } from 'reselect';
import { connect } from 'react-redux';
import {
	StoreAsyncItem as StoreAsyncItemFlux,
	createActionCreatorPack,
	createReducerCreatorPack,
	createSelectorCreatorPack,
	createWithAutoUpdatePack,
} from '@seeneco-ui/core/flux';
import api from '@seeneco-ui/api';

import { IBusinessState as IBusinessRootReducer } from '../root-reducer';


export type StoreAsyncItem<T> = {} & StoreAsyncItemFlux<T>;

export interface IBusinessState {
	$business: IBusinessRootReducer;
}

const actionCreatorPack = createActionCreatorPack<typeof api, IBusinessState>({ api });
const createTypes = actionCreatorPack.createTypes;
const createStaticAction = actionCreatorPack.createStaticAction;
const createAsyncAction = actionCreatorPack.createAsyncAction;

const reducerCreatorPack = createReducerCreatorPack();
const createReducer = reducerCreatorPack.createReducer;
const createAsyncInitialState = reducerCreatorPack.createAsyncInitialState;
const checkAsyncAction = reducerCreatorPack.checkAsyncAction;
const invalidateStateFromAction = reducerCreatorPack.invalidateStateFromAction;

const selectorCreatorPack = createSelectorCreatorPack(createReselectSelector);
const createSelector = selectorCreatorPack.createSelector;
const createAsyncSelector = selectorCreatorPack.createAsyncSelector;

const withAutoUpdatePack = createWithAutoUpdatePack(connect);
const withAutoUpdate = withAutoUpdatePack.withAutoUpdate;

export {
	createTypes,
	createStaticAction,
	createAsyncAction,
	createReducer,
	createAsyncInitialState,
	checkAsyncAction,
	invalidateStateFromAction,
	createSelector,
	createAsyncSelector,
	withAutoUpdate,
};
